import { PublicPageTemplate } from "./PublicPageTemplate";

const BourseIdeesPage = () => (
  <PublicPageTemplate
    badge="Bourse aux idées"
    title="La bourse aux"
    highlight="idées"
    description="Un espace collaboratif pour partager, financer et développer des idées innovantes. Inclut la Banque Anti-Pauvreté."
  />
);
export default BourseIdeesPage;
